import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { AppDispatch, RootState } from '../../store';
import { CiLocationOn } from 'react-icons/ci';
import { FaStar, FaCalendarAlt } from 'react-icons/fa';
import { GrStatusUnknown } from 'react-icons/gr';
import { IoPricetagsOutline } from 'react-icons/io5';
import { MdOutlinePayments } from 'react-icons/md';
import { getStatusClass, formatDateRange } from '../../utils/data';
import { fetchBookByTripId } from '../../features/home/bookTripSlice';
const AdminBookTripDetails = () => {
    const { bookId } = useParams();
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch<AppDispatch>()
    const { booking } = useSelector((state: RootState) => state.bookingTripSlice)


    useEffect(() => {
        dispatch(fetchBookByTripId(Number(bookId)))

    }, [dispatch, bookId])
    return (
        <div>
            <div className="bg-gradient-to-r from-blue-600 to-indigo-500 text-white rounded-xl shadow-md p-6 mb-6">
                <h3 className='text-2xl font-semibold'>{t("book-details")}</h3>

            </div>
            <div className=' bg-white rounded-lg p-4 grid sm:grid-cols-2 xs:grid-cols-1 gap-5'>
                <div>
                    <h3 className='text-xl font-semibold mb-4'>{t("trip")}</h3>
                    <Link to={`/dashboard/trip-details/${booking?.trip?.id}`} className="flex w-full overflow-hidden rounded-2xl border shadow-sm bg-white" >
                        <div className="relative xs:w-32 sm:w-40 overflow-hidden">
                            <img
                                src={booking?.trip?.tripImages?.[0]?.url}
                                alt={booking?.trip?.toLocation}
                                className="w-full h-full object-cover"
                            />
                            <span
                                className={`absolute top-3 ${i18n.language === 'ar' ? 'right-3' : 'left-3'
                                    } rounded-md bg-primary px-3 py-1 text-xs sm:text-sm text-white`}
                            >
                                {booking?.trip?.subCategory?.title}
                            </span>
                        </div>
                        <div className="flex flex-col justify-between flex-1 p-3">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-2 text-sm text-gray-600">
                                    <FaStar className="text-secondry" />
                                    {booking?.trip?.rate?.toFixed(1)}{' '}
                                    <span className="text-gray-400">
                                        ({booking?.trip?.reviews?.length} {t('reviews')})
                                    </span>
                                </div>
                                <span
                                    className={`xs:text-xs sm:text-sm font-medium ${getStatusClass(
                                        booking?.state
                                    )}`}
                                >
                                    {t(`status.${booking?.state.toLowerCase()}`) || booking?.state}
                                </span>
                            </div>
                            <h2 className="mt-1 text-lg font-bold">
                                {t("trip")} {booking?.trip?.fromLocation} {t("to")} {booking?.trip?.toLocation}
                            </h2>
                            <p className="flex items-center gap-1 text-sm text-gray-500">
                                <CiLocationOn /> {booking?.trip?.place.title}
                            </p>
                        </div>
                    </Link>
                    <section className="mt-10  w-full">
                        <h2 className="text-2xl font-semibold mb-4">{t("trip-details")} </h2>
                        <p className=' line-clamp-4 text-textSecond'>{booking?.trip.details}</p>
                    </section>
                </div>
                <div>
                    <h3 className='text-xl font-semibold mb-4'>{t("booking")}</h3>
                    <div className=' flex flex-col justify-between h-full'>
                        <div>
                            <div className="flex-between pt-2 text-sm text-textSecond">
                                <p className="flex items-center gap-1 text-darkColor font-medium">
                                    <FaCalendarAlt />
                                    <span>{t('dates')}</span>
                                </p>
                                {booking?.trip.fromDate && <p>{formatDateRange(booking.trip.fromDate, booking.trip.toDate)}</p>}
                            </div>

                            <div className="flex-between pt-2 text-sm text-textSecond">
                                <p className="flex items-center gap-1 text-darkColor font-medium">
                                    <IoPricetagsOutline />
                                    <span>{t('price')}</span>
                                </p>
                                <p className={` font-medium`}  >
                                    <p>{booking?.price}</p>
                                </p>
                            </div>
                            <div className="flex-between pt-2 text-sm text-textSecond">
                                <p className="flex items-center gap-1 text-darkColor font-medium">
                                    <MdOutlinePayments />
                                    <span>{t('paymentMethod')}</span>
                                </p>
                                <p className={` font-medium`}  >
                                    {t(`${booking?.paymentMethod}`)}
                                </p>
                            </div>
                            <div className="flex-between pt-2 text-sm text-textSecond">
                                <p className="flex items-center gap-1 text-darkColor font-medium">
                                    <GrStatusUnknown />
                                    <span>{t('Status')}</span>
                                </p>
                                <p className={` font-medium ${getStatusClass(booking?.state)}`}  >
                                    {t(`status.${booking?.state.toLowerCase()}`) || booking?.state}
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminBookTripDetails